module.exports = __webpack_public_path__ + "img/cont-09.a1d364ca.svg";